





























































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import jsPDF from 'jspdf';
import {Utils} from '@/utils/Utils';
import autoTable from 'jspdf-autotable';
import html2pdf from 'html2pdf.js';
@Component({})
export default class InspectionDetailsPDF extends Vue {
  @Prop({default: null}) deckImage!: String;
  @Prop({default: null}) inspectionData!: [];

  // mounted() {
  //   this.inspectionData.map((data: any) => {
  //     return {
  //      { displayLabel: 'Inspection ID',
  //       displayValue: data.inspectionCode},

  //     };
  //   });
  //
  // }

  // callChildBtn() {
  //

  //   document.getElementById('btn').click();
  // }
  pdf() {
    html2pdf('html2PdfRef', {
      margin: 0,
      filename: 'myfile.pdf',
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 2},
      jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'},
    });
  }

  // async htmlToPdf() {
  //   html2pdf().from('<h1>Title</h1>').save();
  //

  //   const doc = new jsPDF('p', 'pt', 'A4', true);
  //
  //   const htmlRef: any = this.$refs.html2Pdf as InnerHTML;
  //

  //   // doc.text("Hello world!", 10, 10);
  //   // doc.addImage(this.deckImage, "JPEG", 15, 40, 180, 180,'image','FAST')
  //   // doc.save("a4.pdf");

  //   await doc.html(htmlRef);
  //

  //   //

  //   var string = doc.output('datauristring');
  //
  //   var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
  //   var x = await window.open();
  //   x.document.open();
  //   x.document.write(embed);
  //   x.document.close();
  // }

  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }
}
